<template>
    <div class="mx-8" class2="mx-0 mx-4 sm:mx-8">
        <!-- :autoplay="false" :autoplayHoverPause="true" :perPage="4" :navigationClickTargetSize="2" -->
        <carousel ref="carousel" :loop="true" :perPage="1" :perPageCustom="[[640, 2], [768, 4]]" :navigationEnabled="true" :scrollPerPage="false" :speed="300" :navigationPrevLabel="navigationPrev" :navigationNextLabel="navigationNext" :paginationEnabled="false" paginationColor="#cccccc" paginationActiveColor="#4a5568" paginationActiveColor2="#0168fa">
            <slide v-for="category in categories" :key="category.id">
                <category-card :category="category" />
            </slide>
        </carousel>
    </div>
</template>

<script>
/**
 * @see https://ssense.github.io/vue-carousel/api/
 * @see https://ssense.github.io/vue-carousel/examples/
 * @see https://kenwheeler.github.io/slick/
 * @see https://themepixels.me/dashforge/components/el-carousel.html
 */
import { Carousel, Slide } from 'vue-carousel';

export default {
    props: ['categories'],

    components: {
        Carousel,
        Slide
    },

    data: () => ({}),

    created() {},

    mounted() {
        /**
         * @see https://github.com/SSENSE/vue-carousel/issues/291
         */
		// setTimeout(() => {
            const carousel = this.$refs['carousel'];
            carousel['offset'] = '0';
			// carousel.onResize();
			// carousel.goToPage(0);
		// }, 1000);
    },

    computed: {
        /**
         * @see https://github.com/SSENSE/vue-carousel/issues/21
         */
        navigationPrev() {
            return '<i class="fad fa-chevron-square-left fa-lg" class2="fa-2x"></i>';
        },

        /**
         * @see https://github.com/SSENSE/vue-carousel/issues/21
         */
        navigationNext() {
            return '<i class="fad fa-chevron-square-right fa-lg" class2="fa-2x"></i>';
        }
    },

    methods: {}
}
</script>

<style lang="scss">
.VueCarousel-navigation-button {
    // font-size: 2rem;
    // color: #0168fa !important;
    color: #4a5568 !important;
    outline: none;
}

.VueCarousel-navigation-button:focus {
    outline: none !important;
}
</style>
